(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/components/betslip-confirm.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/components/betslip-confirm.js');

'use strict';

const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.page_play.jotai.atoms,
  locationConfirmedAtom = _svs$lyckoplatsen$com.locationConfirmedAtom,
  pinLocationTypeAtom = _svs$lyckoplatsen$com.pinLocationTypeAtom;
const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue,
  useSetAtom = _jotai.useSetAtom;
const isSelfService = svs.core.config.data.svsconfig.isSelfService;
const CharityLogo = svs.lyckoplatsen.components.page_play.react.components.CharityLogo;
const Button = svs.ui.ReactButton;
const BetslipConfirm = () => {
  const setLocationConfirmed = useSetAtom(locationConfirmedAtom);
  const pinLocationType = useAtomValue(pinLocationTypeAtom);
  const handleClick = () => {
    svs.components.analytics.trackEvent({
      category: 'Lyckoplatsen',
      action: 'Spela här',
      opt_label: pinLocationType
    });
    setLocationConfirmed(true);
  };
  return React.createElement("div", {
    className: "lp-betslip-confirm"
  }, React.createElement(CharityLogo, {
    className: "charity-logo"
  }), React.createElement(Button, {
    block: true,
    size: isSelfService ? 700 : 500,
    className: "lp-green",
    onClick: handleClick
  }, "Spela h\xE4r"));
};
setGlobal('svs.lyckoplatsen.components.page_play.react.components', {
  BetslipConfirm
});

 })(window);